import React, { forwardRef } from "react";
import { urlRegexValidator, FieldTypes } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import DeepfenceMappingForm from "./DeepfenceMappingForm";

export default forwardRef(function DeepfenceCredentialForm(props, ref) {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      required: true,
      rules: [urlRegexValidator],
    },
    {
      name: "apiKey",
      label: "API Key",
      required: true,
      type: FieldTypes.PASSWORD,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={DeepfenceMappingForm}
    />
  );
});
